import { MenuItem } from "@chakra-ui/react";
import { useActiveAccount } from "applesauce-react/hooks";
import { NostrEvent } from "nostr-tools";

import { useReportModalContext } from "../../providers/route/report-modal-provider";
import Flag01 from "../icons/flag-01";

export default function ReportEventMenuItem({ event }: { event: NostrEvent }) {
  const account = useActiveAccount();
  const { openModal } = useReportModalContext();

  if (account?.pubkey === event.pubkey) return null;

  return (
    <MenuItem onClick={() => openModal(event)} icon={<Flag01 />} color="red.500">
      Report
    </MenuItem>
  );
}
